/*
  This code is the intellectual property of Bulb Inc. and other software publishers;
  it may not be altered, copied or disclosed without prior written approval.
  Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { MenuItem } from '../types';

/**
 * Given a list of menu items, return all models found.
 * Used for grouping menuItems by model.
 */
export function getMenuItemModels(menuItems: Array<MenuItem>): Array<string> {
  return [...new Set(menuItems.map(({ model }) => model))];
}

/**
 * Given a list of menu items and a value, find item with the value, v.
 */
export function findSelectedOption(menuItems: Array<MenuItem>, v: string): MenuItem {
  const fields = menuItems?.find(({ value }) => value === v);
  return fields?.value;
}
